class ProfileService {
    constructor() {
        this.controller = null;
    }

    updateContactInfo = (url, method, data) => {
        const controller = new AbortController();
        const signal = controller.signal;

        this.controller = controller;

        return fetch(url, {
            method,
            signal,
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
            },
        })
    }

    abortContactInfoUpdating = () => {
        if (this.controller) {
            this.controller.abort();
        }
    }
}

export default new ProfileService();
